exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pipeline-template-variable .add-new:hover,\n.pipeline-template-variable .add-new:focus,\n.pipeline-template-variable .add-new:active {\n  background-color: transparent;\n}\n.pipeline-template-variable code {\n  color: var(--color-black);\n  margin-right: 3px;\n  max-width: 100px;\n  word-break: break-all;\n}\n", ""]);

